// 文化考核
const assessmentRouter =
{
  path: '/culture',
  name: 'Culture',
  redirect: '/culture',
  meta: {
    title: '企业文化考核'
  },
  component: () => import('@/views/assessment/assBase.vue'),
  children:
    [
      {
        path: '/',
        name: 'Index',
        component: () => import('@/views/assessment/index'),
        meta: { title: '企业文化考核' }
      },
      // 填写页面
      {
        path: 'estimate',
        name: 'Estimate',
        component: () => import('@/views/assessment/estimate'),
        meta: { title: '企业文化考核' }
      },
      // 列表展示
      {
        path: 'exhibition',
        name: 'Exhibition',
        component: () => import('@/views/assessment/exhibition'),
        meta: { title: '企业文化考核' }
      },
      {
        path: 'doResult',
        name: 'Result',
        component: () => import('@/views/assessment/submitResult'),
        meta: { title: '企业文化考核' }
      }
    ]
}
export default assessmentRouter
